import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatListModule} from "@angular/material/list";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {HttpService} from "../../services/http/http.service";
import {AdaService} from "../../services/ada/ada.service";
import {AtecoService} from "../../services/ateco/ateco.service";
import {IscoService} from "../../services/isco/isco.service";
import {IstatService} from "../../services/istat/istat.service";


@Component({
  selector: 'details-proposta-competenza-dialog',
  templateUrl: './details-proposta-competenza-dialog.component.html',
  styleUrls: ['./details-proposta-competenza-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatListModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule, MatTooltipModule],
})
export class DetailsPropostaCompetenzaDialog implements OnInit {
  pdfVisible: boolean;
  xlsVisible: boolean;
  listaAda: any;
  listaAteco: any;
  listaIsco: any;
  listaIstat: any;
  constructor(
    public dialogRef: MatDialogRef<DetailsPropostaCompetenzaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private ada: AdaService,
    private ateco: AtecoService,
    private isco: IscoService,
    private istat: IstatService
  ) { }

  ngOnInit(): void {
    this.pdfVisible = this.data.competenza.stato.id === 5 || this.data.competenza.stato.id === 7
      || this.data.competenza.stato.id === 4;

    this.xlsVisible = this.data.competenza.stato.id === 3 || this.data.competenza.stato.id === 4
      || this.data.competenza.stato.id === 5 || this.data.competenza.stato.id === 7
      || this.data.competenza.stato.id === 9 || this.data.competenza.stato.id === 10
      || this.data.competenza.stato.id === 11;

    this.ada.getCodiciAdaByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaAda = response.result;
      }
    });

    this.ateco.getCodiciAtecoByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaAteco = response.result;
      }
    });

    this.isco.getCodiciIscoByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaIsco = response.result;
      }
    });

    this.istat.getCodiciIstatByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaIstat = response.result;
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  reportPropostaCompetenzaPdf() {
    this.api.reportPropostaCompetenzaPdf(this.data.competenza.id);
  }

  reportPropostaCompetenzaXls() {
    this.api.reportPropostaCompetenzaXls(this.data.competenza.id);
  }
}
